import { PanelBody, PanelRow, RangeControl, __experimentalUnitControl as UnitControl } from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { BDevice, Label } from '../../../../Components'
import { emUnit, perUnit, pxUnit } from '../../../../Components/utils/options';


const GridLayoutPanel = ({ device, setDevice, attributes, setAttributes }) => {
    const { columns, columnGap, rowGap } = attributes;
    return <PanelBody title={__('Grid Layout', 'swipe-n-buy')} initialOpen={false}>
        <PanelRow>
            <Label mt='0'>{__('Columns:', 'b-testimonials-block')}</Label>
            <BDevice device={device} onChange={val => setDevice(val)} />
        </PanelRow>

        <RangeControl value={columns[device]} onChange={val => { setAttributes({ columns: { ...columns, [device]: val } }) }} min={1} max={6} step={1} beforeIcon='grid-view' />

        <UnitControl className='mt20' label={__('Column Gap:', 'b-testimonials-block')} labelPosition='left' value={columnGap} onChange={val => setAttributes({ columnGap: val })} units={[pxUnit(30), perUnit(3), emUnit(2)]} isResetValueOnUnitChange={true} />

        <UnitControl className='mt20' label={__('Row Gap:', 'b-testimonials-block')} labelPosition='left' value={rowGap} onChange={val => setAttributes({ rowGap: val })} units={[pxUnit(40), perUnit(3), emUnit(2.5)]} isResetValueOnUnitChange={true} />
    </PanelBody>

}
export default GridLayoutPanel